<template>
  <div>
    <!-- Label -->
    <label v-if="label" :for="name" class="inputLabel">
      {{ label }}
      <span v-if="required" class="requiredStar">*</span>
    </label>

    <div
      class="inputWrapper"
      :class="[
        error && touched && required ? 'inputError' : '',
        editorFocus ? 'editorFocus' : '',
      ]"
      style="margin: 8px auto; border-radius: 5px;"
    >
      <div
        class="editorButtons"
        :class="error ? 'buttonsError' : ''"
        ref="buttons"
      >
        <button ref="boldActionBtn" @mousedown="format($event, 'bold')">
          <svg
            width="10"
            height="11"
            viewBox="0 0 10 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.64844 5.21875C8.16406 5.40625 8.5625 5.71094 8.86719 6.13281C9.14844 6.57812 9.3125 7.09375 9.3125 7.70312C9.3125 8.40625 9.10156 9.01562 8.72656 9.53125C8.32812 10.0469 7.83594 10.3984 7.22656 10.5625C6.80469 10.7031 6.26562 10.75 5.65625 10.75H1.0625C0.945312 10.75 0.851562 10.7266 0.78125 10.6562C0.710938 10.5859 0.6875 10.4922 0.6875 10.375V9.625C0.6875 9.53125 0.710938 9.4375 0.78125 9.36719C0.851562 9.29688 0.945312 9.25 1.0625 9.25H1.83594V1.77344H1.0625C0.945312 1.77344 0.851562 1.75 0.78125 1.67969C0.710938 1.60938 0.6875 1.51562 0.6875 1.39844V0.625C0.6875 0.53125 0.710938 0.4375 0.78125 0.367188C0.851562 0.296875 0.945312 0.25 1.0625 0.25H5.42188C5.79688 0.25 6.125 0.273438 6.40625 0.296875C6.71094 0.34375 7.01562 0.4375 7.29688 0.53125C7.78906 0.71875 8.1875 1.04688 8.46875 1.46875C8.75 1.91406 8.89062 2.40625 8.89062 2.96875C8.89062 3.46094 8.77344 3.90625 8.5625 4.30469C8.32812 4.70312 8.02344 5.00781 7.64844 5.21875ZM3.82812 1.86719V4.51562H5.63281C6.00781 4.51562 6.3125 4.39844 6.54688 4.16406C6.75781 3.92969 6.875 3.60156 6.875 3.17969C6.875 2.92188 6.80469 2.6875 6.71094 2.47656C6.61719 2.28906 6.47656 2.125 6.28906 2.03125C6.05469 1.9375 5.77344 1.86719 5.42188 1.86719H3.82812ZM6.47656 9.01562C6.71094 8.92188 6.92188 8.75781 7.0625 8.47656C7.20312 8.21875 7.29688 7.91406 7.29688 7.58594C7.29688 7.14062 7.15625 6.78906 6.89844 6.50781C6.61719 6.25 6.26562 6.10938 5.82031 6.10938H3.82812V9.13281H5.72656C6.03125 9.13281 6.28906 9.10938 6.47656 9.01562Z"
              fill="#5C5F62"
            />
          </svg>
        </button>
        <button ref="italicActionBtn" @mousedown="format($event, 'italic')">
          <svg
            width="8"
            height="11"
            viewBox="0 0 8 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.05469 9.25C5.14844 9.25 5.24219 9.29688 5.33594 9.39062C5.40625 9.48438 5.42969 9.60156 5.40625 9.69531L5.26562 10.4453C5.24219 10.5391 5.19531 10.6328 5.125 10.6797C5.05469 10.7266 4.98438 10.75 4.91406 10.75H1.1875C1.04688 10.75 0.953125 10.7031 0.882812 10.6094C0.8125 10.5156 0.789062 10.4219 0.8125 10.3047L0.976562 9.55469C0.976562 9.46094 1.02344 9.39062 1.09375 9.34375C1.16406 9.29688 1.23438 9.25 1.32812 9.25H2.26562L3.71875 1.75H2.92188C2.78125 1.75 2.6875 1.70312 2.61719 1.60938C2.54688 1.51562 2.52344 1.42188 2.54688 1.30469L2.71094 0.554688C2.71094 0.460938 2.75781 0.390625 2.82812 0.34375C2.875 0.296875 2.96875 0.25 3.0625 0.25H6.8125C6.92969 0.25 7.02344 0.296875 7.09375 0.390625C7.16406 0.484375 7.1875 0.601562 7.1875 0.695312L7.02344 1.44531C7 1.53906 6.95312 1.63281 6.88281 1.67969C6.8125 1.72656 6.74219 1.75 6.67188 1.75H5.71094L4.25781 9.25H5.05469Z"
              fill="#5C5F62"
            />
          </svg>
        </button>
        <button
          ref="underlineActionBtn"
          @mousedown="format($event, 'underline')"
        >
          <svg
            width="12"
            height="13"
            viewBox="0 0 12 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 9.59375C7.10156 9.59375 7.99219 9.3125 8.64844 8.70312C9.30469 8.07031 9.65625 7.17969 9.65625 6.05469V2H10.3359C10.4297 2 10.5 1.97656 10.5938 1.90625C10.6641 1.83594 10.7109 1.74219 10.7109 1.625V0.875C10.7109 0.78125 10.6641 0.6875 10.5938 0.617188C10.5 0.546875 10.4297 0.5 10.3359 0.5H7.125C7.00781 0.5 6.91406 0.546875 6.84375 0.617188C6.77344 0.6875 6.75 0.78125 6.75 0.875V1.625C6.75 1.74219 6.77344 1.83594 6.84375 1.90625C6.91406 1.97656 7.00781 2 7.125 2H7.78125V6.03125C7.78125 6.66406 7.61719 7.13281 7.3125 7.4375C6.98438 7.76562 6.5625 7.90625 6 7.90625C5.4375 7.90625 4.99219 7.76562 4.6875 7.4375C4.35938 7.13281 4.21875 6.66406 4.21875 6.05469V2H4.89844C4.99219 2 5.0625 1.97656 5.15625 1.90625C5.22656 1.83594 5.27344 1.74219 5.27344 1.625V0.875C5.27344 0.78125 5.22656 0.6875 5.15625 0.617188C5.0625 0.546875 4.99219 0.5 4.89844 0.5H1.66406C1.57031 0.5 1.47656 0.546875 1.40625 0.617188C1.3125 0.6875 1.28906 0.78125 1.28906 0.875V1.625C1.28906 1.74219 1.3125 1.83594 1.40625 1.90625C1.47656 1.97656 1.57031 2 1.66406 2H2.34375V6.05469C2.34375 7.20312 2.67188 8.09375 3.375 8.70312C4.00781 9.3125 4.875 9.59375 6 9.59375ZM1.125 11C1.00781 11 0.914062 11.0469 0.84375 11.1172C0.773438 11.1875 0.75 11.2812 0.75 11.375V12.125C0.75 12.2422 0.773438 12.3359 0.84375 12.4062C0.914062 12.4766 1.00781 12.5 1.125 12.5H10.875C10.9688 12.5 11.0625 12.4766 11.1328 12.4062C11.2031 12.3359 11.25 12.2422 11.25 12.125V11.375C11.25 11.2812 11.2031 11.1875 11.1328 11.1172C11.0625 11.0469 10.9688 11 10.875 11H1.125Z"
              fill="#5C5F62"
            />
          </svg>
        </button>
        <button
          ref="removeActionBtn"
          @mousedown="format($event, 'removeFormat')"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.6719 6.42188L8.34375 9.75H11.7188C11.7891 9.75 11.8594 9.79688 11.9062 9.84375C11.9531 9.89062 12 9.96094 12 10.0312V10.9688C12 11.0625 11.9531 11.1328 11.9062 11.1797C11.8594 11.2266 11.7891 11.25 11.7188 11.25H3.375C3.04688 11.25 2.78906 11.1562 2.57812 10.9219L0.328125 8.67188C0.09375 8.46094 0 8.20312 0 7.875C0 7.57031 0.09375 7.3125 0.328125 7.07812L6.32812 1.07812C6.53906 0.867188 6.79688 0.75 7.125 0.75C7.42969 0.75 7.6875 0.867188 7.92188 1.07812L11.6719 4.82812C11.8828 5.0625 12 5.32031 12 5.625C12 5.95312 11.8828 6.21094 11.6719 6.42188ZM4.57031 4.94531L1.66406 7.875L3.53906 9.75H6.21094L7.80469 8.17969L4.57031 4.94531Z"
              fill="#5C5F62"
            />
          </svg>
        </button>
        <button
          ref="insertOrderedListActionBtn"
          @mousedown="format($event, 'insertOrderedList')"
        >
          <svg
            width="12"
            height="11"
            viewBox="0 0 12 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.0703125 2.78125V2.96875C0.0703125 3.15625 0.164062 3.25 0.351562 3.25H1.92188C2.10938 3.25 2.20312 3.15625 2.20312 2.96875V2.78125C2.20312 2.59375 2.10938 2.5 1.92188 2.5H1.57031V0.53125C1.57031 0.34375 1.47656 0.25 1.28906 0.25H1.00781C0.867188 0.25 0.75 0.296875 0.65625 0.390625L0.164062 0.859375C0.0234375 1 0 1.11719 0.140625 1.23438L0.28125 1.375C0.328125 1.44531 0.375 1.49219 0.445312 1.49219C0.515625 1.49219 0.585938 1.46875 0.632812 1.39844L0.726562 1.32812L0.703125 1.5625V2.5H0.351562C0.164062 2.5 0.0703125 2.59375 0.0703125 2.78125ZM0.046875 6.64844V6.74219C0.046875 6.83594 0.0703125 6.88281 0.117188 6.92969C0.164062 6.97656 0.234375 7 0.328125 7H1.92188C2.10938 7 2.20312 6.92969 2.20312 6.74219V6.53125C2.20312 6.34375 2.10938 6.25 1.92188 6.25H1.00781C1.00781 6.20312 1.125 6.13281 1.33594 6.01562C1.57031 5.875 1.75781 5.73438 1.875 5.61719C2.0625 5.42969 2.15625 5.19531 2.15625 4.9375C2.15625 4.63281 2.03906 4.39844 1.80469 4.21094C1.61719 4.07031 1.38281 4 1.10156 4C0.679688 4 0.375 4.16406 0.164062 4.44531C0.0703125 4.58594 0.09375 4.70312 0.234375 4.79688L0.421875 4.96094C0.539062 5.05469 0.65625 5.05469 0.796875 4.91406C0.867188 4.86719 0.9375 4.82031 1.03125 4.82031C1.17188 4.82031 1.24219 4.89062 1.24219 5.00781C1.24219 5.05469 1.21875 5.10156 1.17188 5.14844C1.125 5.19531 1.03125 5.26562 0.914062 5.33594C0.65625 5.52344 0.46875 5.66406 0.351562 5.80469C0.140625 6.03906 0.046875 6.32031 0.046875 6.64844ZM0.140625 10.1641C0.046875 10.3047 0.046875 10.4453 0.1875 10.5391C0.421875 10.6797 0.703125 10.75 1.03125 10.75C1.40625 10.75 1.6875 10.6562 1.89844 10.4219C2.08594 10.2344 2.17969 10 2.17969 9.71875C2.17969 9.53125 2.10938 9.36719 1.99219 9.22656C1.875 9.08594 1.71094 8.96875 1.5 8.89844L1.89844 8.42969C1.99219 8.33594 2.03906 8.24219 2.03906 8.10156V8.00781C2.03906 7.84375 1.94531 7.75 1.75781 7.75H0.398438C0.210938 7.75 0.117188 7.84375 0.117188 8.00781V8.21875C0.117188 8.40625 0.210938 8.5 0.398438 8.5H0.703125L0.984375 8.45312V8.47656C0.890625 8.57031 0.796875 8.66406 0.703125 8.78125L0.5625 8.94531C0.46875 9.08594 0.445312 9.20312 0.515625 9.29688L0.539062 9.34375C0.585938 9.48438 0.679688 9.53125 0.820312 9.53125H0.9375C1.17188 9.53125 1.3125 9.60156 1.3125 9.74219C1.3125 9.88281 1.19531 9.92969 0.960938 9.92969C0.84375 9.92969 0.726562 9.90625 0.632812 9.85938C0.46875 9.76562 0.351562 9.78906 0.257812 9.92969L0.140625 10.1641ZM3.375 2.59375C3.25781 2.59375 3.16406 2.57031 3.09375 2.5C3.02344 2.42969 3 2.33594 3 2.21875V1.28125C3 1.1875 3.02344 1.09375 3.09375 1.02344C3.16406 0.953125 3.25781 0.90625 3.375 0.90625H11.625C11.7188 0.90625 11.8125 0.953125 11.8828 1.02344C11.9531 1.09375 12 1.1875 12 1.28125V2.21875C12 2.33594 11.9531 2.42969 11.8828 2.5C11.8125 2.57031 11.7188 2.59375 11.625 2.59375H3.375ZM3.375 6.34375C3.25781 6.34375 3.16406 6.32031 3.09375 6.25C3.02344 6.17969 3 6.08594 3 5.96875V5.03125C3 4.9375 3.02344 4.84375 3.09375 4.77344C3.16406 4.70312 3.25781 4.65625 3.375 4.65625H11.625C11.7188 4.65625 11.8125 4.70312 11.8828 4.77344C11.9531 4.84375 12 4.9375 12 5.03125V5.96875C12 6.08594 11.9531 6.17969 11.8828 6.25C11.8125 6.32031 11.7188 6.34375 11.625 6.34375H3.375ZM3.375 10.0938C3.25781 10.0938 3.16406 10.0703 3.09375 10C3.02344 9.92969 3 9.83594 3 9.71875V8.78125C3 8.6875 3.02344 8.59375 3.09375 8.52344C3.16406 8.45312 3.25781 8.40625 3.375 8.40625H11.625C11.7188 8.40625 11.8125 8.45312 11.8828 8.52344C11.9531 8.59375 12 8.6875 12 8.78125V9.71875C12 9.83594 11.9531 9.92969 11.8828 10C11.8125 10.0703 11.7188 10.0938 11.625 10.0938H3.375Z"
              fill="#5C5F62"
            />
          </svg>
        </button>
        <button
          ref="insertUnorderedListActionBtn"
          @mousedown="format($event, 'insertUnorderedList')"
        >
          <svg
            width="12"
            height="11"
            viewBox="0 0 12 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.25 1.75C2.25 1.44531 2.13281 1.1875 1.92188 0.953125C1.6875 0.742188 1.42969 0.625 1.125 0.625C0.796875 0.625 0.539062 0.742188 0.328125 0.953125C0.09375 1.1875 0 1.44531 0 1.75C0 2.07812 0.09375 2.33594 0.328125 2.54688C0.539062 2.78125 0.796875 2.875 1.125 2.875C1.42969 2.875 1.6875 2.78125 1.92188 2.54688C2.13281 2.33594 2.25 2.07812 2.25 1.75ZM1.125 4.375C1.42969 4.375 1.6875 4.49219 1.92188 4.70312C2.13281 4.9375 2.25 5.19531 2.25 5.5C2.25 5.82812 2.13281 6.08594 1.92188 6.29688C1.6875 6.53125 1.42969 6.625 1.125 6.625C0.796875 6.625 0.539062 6.53125 0.328125 6.29688C0.09375 6.08594 0 5.82812 0 5.5C0 5.19531 0.09375 4.9375 0.328125 4.70312C0.539062 4.49219 0.796875 4.375 1.125 4.375ZM1.125 8.125C1.42969 8.125 1.6875 8.24219 1.92188 8.45312C2.13281 8.6875 2.25 8.94531 2.25 9.25C2.25 9.57812 2.13281 9.83594 1.92188 10.0469C1.6875 10.2812 1.42969 10.375 1.125 10.375C0.796875 10.375 0.539062 10.2812 0.328125 10.0469C0.09375 9.83594 0 9.57812 0 9.25C0 8.94531 0.09375 8.6875 0.328125 8.45312C0.539062 8.24219 0.796875 8.125 1.125 8.125ZM3.375 2.59375C3.25781 2.59375 3.16406 2.57031 3.09375 2.5C3.02344 2.42969 3 2.33594 3 2.21875V1.28125C3 1.1875 3.02344 1.09375 3.09375 1.02344C3.16406 0.953125 3.25781 0.90625 3.375 0.90625H11.625C11.7188 0.90625 11.8125 0.953125 11.8828 1.02344C11.9531 1.09375 12 1.1875 12 1.28125V2.21875C12 2.33594 11.9531 2.42969 11.8828 2.5C11.8125 2.57031 11.7188 2.59375 11.625 2.59375H3.375ZM3.375 6.34375C3.25781 6.34375 3.16406 6.32031 3.09375 6.25C3.02344 6.17969 3 6.08594 3 5.96875V5.03125C3 4.9375 3.02344 4.84375 3.09375 4.77344C3.16406 4.70312 3.25781 4.65625 3.375 4.65625H11.625C11.7188 4.65625 11.8125 4.70312 11.8828 4.77344C11.9531 4.84375 12 4.9375 12 5.03125V5.96875C12 6.08594 11.9531 6.17969 11.8828 6.25C11.8125 6.32031 11.7188 6.34375 11.625 6.34375H3.375ZM3.375 10.0938C3.25781 10.0938 3.16406 10.0703 3.09375 10C3.02344 9.92969 3 9.83594 3 9.71875V8.78125C3 8.6875 3.02344 8.59375 3.09375 8.52344C3.16406 8.45312 3.25781 8.40625 3.375 8.40625H11.625C11.7188 8.40625 11.8125 8.45312 11.8828 8.52344C11.9531 8.59375 12 8.6875 12 8.78125V9.71875C12 9.83594 11.9531 9.92969 11.8828 10C11.8125 10.0703 11.7188 10.0938 11.625 10.0938H3.375Z"
              fill="#5C5F62"
            />
          </svg>
        </button>
      </div>
      <div
        :id="id"
        class="textEditorContentArea"
        :class="error ? 'contentError' : ''"
        ref="content"
        contenteditable
        @input="onInput"
        @keydown="onKeydown"
        @focus="focus"
        @blur="blur"
        @paste.prevent="onPaste"
        :placeholder="placeholder"
        v-html="htmlString"
      />
      <div
        class="countArea noselect"
        :class="error ? 'countError' : ''"
        ref="count"
      >
        <span v-if="limit > 0">{{ characterCount }} / {{ limit }}</span>
        <span v-if="!limit || limit === 0">{{ characterCount }}</span>
      </div>
    </div>
    <!-- <div
      v-if="error && touched && required"
      class="flex items-center pointer-events-none"
    >
      <svg class="h-5 w-5 text-red-medium" fill="#ff5252" viewBox="0 0 20 20">
        <path
          fill-rule="evenodd"
          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
          clip-rule="evenodd"
        />
      </svg>
      <p class="inputErrorText">
        {{ errorText }}
      </p>
    </div> -->
  </div>
</template>

<script>
import {
  clipHtml,
  convertPlainTextToHtml,
  charCountForHtmlContent,
} from '@/utils/Inputs/htmlManipulationFunctions';

const exec = command => document.execCommand(command, false, null);
const actionsBtns = [
  'bold',
  'italic',
  'underline',
  'insertOrderedList',
  'insertUnorderedList',
];
export default {
  name: 'TextEditor',
  data() {
    return {
      touched: false,
      error: false,
      success: false,
      editorFocus: false,
      htmlString: '',
      newString: null,
      characterCount: 0,
    };
  },
  beforeUpdate() {
    if (!this.editorFocus) {
      this.htmlString = convertPlainTextToHtml(this.value);
    }
  },
  watch: {
    value: function(val) {
      // this.htmlString = convertPlainTextToHtml(val);
      this.setChars(val);
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.htmlString === '' && this.value && this.value !== '') {
        this.htmlString = convertPlainTextToHtml(this.value);
      }
      this.setChars(this.htmlString);
    });
  },
  computed: {
    errorText() {
      if (this.limit > 0 && this.characterCount > this.limit) {
        return 'Too many characters for ' + this.label.toLowerCase();
      }
      return this.label + ' is required';
    },
  },
  methods: {
    focus() {
      this.editorFocus = true;
      document.onselectionchange = () => {
        actionsBtns.forEach(a => {
          const refBtn = this.$refs[a + 'ActionBtn'];
          if (refBtn) {
            refBtn.classList.toggle(
              'is-active',
              this.isSelectionCommandActive(a)
            );
          }
        });
      };
    },
    isSelectionCommandActive(command) {
      return document.queryCommandState(command);
    },
    blur() {
      this.editorFocus = false;
      if (this.newString !== null) {
        actionsBtns.forEach(a => {
          const refBtn = this.$refs[a + 'ActionBtn'];
          if (refBtn) {
            refBtn.classList.remove('is-active');
          }
        });
      }
    },
    format(event, command, value) {
      event.preventDefault();
      exec(command, value);
    },
    setChars(string) {
      this.characterCount = charCountForHtmlContent(string);
    },
    onInput(e) {
      const htmlVal = e.target.innerHTML;
      this.newString = htmlVal;
      this.touched = true;
      this.setChars(htmlVal);

      this.$emit('input-change', {
        key: this.name,
        value: htmlVal,
      });

      this.error = false;
      this.success = true;
      this.$emit('error-change', false);
      this.$refs.buttons.classList.remove('buttonsError');
      this.$refs.content.classList.remove('contentError');
      this.$refs.count.classList.remove('countError');
    },
    onKeydown(e) {
      // command or ctrl check mac
      if (e.ctrlKey || e.metaKey) {
        switch (e.key.toLowerCase()) {
          case 'b':
            e.preventDefault();
            this.$nextTick(() => exec('bold'));
            break;
          case 'i':
            e.preventDefault();
            this.$nextTick(() => exec('italic'));
            break;
          case 'u':
            e.preventDefault();
            this.$nextTick(() => exec('underline'));
            break;
          default:
            break;
        }
      }
      if (this.limit && this.limit > 0) {
        if (this.characterCount >= this.limit) {
          if (
            e.keyCode !== 8 &&
            e.keyCode !== 38 &&
            e.keyCode !== 39 &&
            e.keyCode !== 40 &&
            e.keyCode !== 41 &&
            e.keyCode !== 46 &&
            e.keyCode !== 16 &&
            e.keyCode !== 17 &&
            e.keyCode !== 18
          ) {
            e.preventDefault();
          }
        }
      }
    },
    onPaste(e) {
      const isPastingPlainText =
        e.clipboardData.types.length === 1 &&
        e.clipboardData.types.includes('text/plain');

      let strLen = 0;
      let processedText = e.clipboardData.getData(
        `text/${isPastingPlainText ? 'plain' : 'html'}`
      );
      let doc = new DOMParser().parseFromString(processedText, 'text/html');
      doc.querySelectorAll('body > *, *[style]').forEach(elem => {
        elem.className = '';
        elem.style.fontSize = '14px';
        elem.style.backgroundColor = 'unset';
        elem.style.background = 'unset';
        elem.style.color = '#000000';
        elem.style.fontFamily = 'Open Sans, sans-serif';
      });
      processedText = doc.body.innerHTML;
      strLen = doc.documentElement.textContent.length;

      if (isPastingPlainText) {
        processedText = convertPlainTextToHtml(processedText);
      }

      if (this.characterCount + strLen > this.limit) {
        processedText = clipHtml(
          processedText,
          this.limit - this.characterCount
        );
      }
      document.execCommand('insertHTML', false, processedText);
      e.preventDefault();
    },
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    limit: {
      type: Number,
      default: 0,
    },
    required: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.editorFocus {
  box-shadow: 0 0 0 2px #3b89ff;

  .is-active {
    background: #6d7175;
    border-radius: 4px;

    svg {
      path {
        fill: #ffffff;
      }
    }
  }
}
.textEditorContentArea {
  display: block;
  min-height: 150px;
  max-height: 550px;
  width: 100%;
  border: 1px solid $border-default;
  background: #fff;
  border-radius: 0 0 5px 5px;
  padding: 8px 8px 24px;
  line-height: 20px;
  resize: vertical;
  overflow: auto;
  font-size: 14px;
  * {
    font-size: 14px;
    color: #000000;
    font-family: $font-family;

    &:hover,
    &:active,
    &:focus {
      background-color: #fff;
    }

    tr {
      &:hover {
        cursor: default;
      }
    }
  }
}
[contenteditable][placeholder]:empty {
  &:not(:focus):before,
  :before {
    content: attr(placeholder);
    position: absolute;
    color: gray;
    background-color: transparent;
    pointer-events: none;
    display: block; /* For Firefox */
  }
}
.textEditorContentArea ul {
  list-style-type: disc;
  list-style-position: inside;
}
.textEditorContentArea ol {
  list-style-type: decimal;
  list-style-position: inside;
}
.editorButtons {
  margin-top: -2px;
  border: 1px solid $border-default;
  border-bottom: 0;
  border-radius: 5px 5px 0 0;
  background: #f6f6f7;
  padding: 3px;
}
.editorButtons button {
  padding: 6px 8px;
  font-size: 16px;
  margin: 0 0.1rem;

  &:hover:not(.is-active) {
    background: #e4e5e7;
    border-radius: 4px;
  }
}
.countArea {
  font-size: 12px;
  color: #969ba0;
  background: #ffffff;
  padding: 0 5px 4px 0;
  border-radius: 5px;
  font-weight: 600;
  line-height: initial;
  position: absolute;
  right: 11px;
  left: 8px;
  bottom: 1px;
  text-align: right;
}

.inputError {
  border-color: #ff5252;
  color: #202223;
  &::placeholder {
    color: #969ba0 !important;
  }
}
.inputErrorText {
  color: #951a1a;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  margin-left: 4px;
}
.contentError {
  border-left: 1px solid #fd5749;
  border-right: 1px solid #fd5749;
  border-bottom: 1px solid #fd5749;
  background: #fff4f4;
}
.buttonsError {
  border-left: 1px solid #fd5749;
  border-right: 1px solid #fd5749;
  border-top: 1px solid #fd5749;
}
.countError {
  background: #fff4f4;
}

.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
